module.exports = __webpack_public_path__ + "static/WEDDING E&M-15-e126983599396fc21d60266fe8399085.jpg";